import React, { useState } from "react";
import { getAllCallsFromDb } from "../../api";
import { SearchForm } from "../../features/search-form/SearchForm";
import { LeadCard } from "../../entities/lead/LeadCard";

export const SearchPage = () => {
  const [leads, setLeads] = useState([]);
  const [loading, setLoading] = useState(false);
  const [apiError, setApiError] = useState(null);
  
  const [searchPeriod, setSearchPeriod] = useState("");
  const [clientId, setClientId] = useState("");
  const [, setSearchParams] = useState({ startDate: null, endDate: null });

  // Обработчик поиска сделок
  const handleSearch = async (clientId, startDate, endDate) => {
    setLoading(true);
    setApiError(null);
    setLeads([]);
    setClientId(clientId);
    setSearchParams({ startDate, endDate });

    // Формируем строку для отображения периода
    let periodString = "";
    if (startDate && endDate) {
      periodString = `с ${startDate} по ${endDate}`;
    } else if (startDate) {
      periodString = `начиная с ${startDate}`;
    } else if (endDate) {
      periodString = `до ${endDate}`;
    }
    setSearchPeriod(periodString);

    try {
      console.log(`Получение сделок для клиента ${clientId} за период: ${periodString || 'все время'}`);
      const callsData = await getAllCallsFromDb(clientId, 500, 0, startDate, endDate);

      if (!callsData || !callsData.success) {
        throw new Error(
          callsData?.message || "Произошла ошибка при получении сделок"
        );
      }

      console.log(`Получено звонков: ${callsData.data.calls.length}`);

      // Шаг 3: Преобразуем звонки в сделки, группируя по lead_id
      const leadsMap = {};

      callsData.data.calls.forEach((call) => {
        if (!call.lead_id) return; // пропускаем звонки без привязки к сделке

        // Если сделки еще нет в карте, создаем её
        if (!leadsMap[call.lead_id]) {
          leadsMap[call.lead_id] = {
            id: call.lead_id,
            name: call.lead_name || `Сделка #${call.lead_id}`,
            created_date: call.created_date || "Неизвестно",
            administrator: call.administrator, // Присваиваем из первого звонка
            calls: [], // Создаем массив для хранения звонков
          };
        }

        // Если у сделки еще нет ответственного, а у текущего звонка есть - обновляем.
        if (!leadsMap[call.lead_id].administrator && call.administrator) {
          leadsMap[call.lead_id].administrator = call.administrator;
        }

        // Добавляем звонок в массив
        leadsMap[call.lead_id].calls.push(call);
      });

      // Преобразуем карту сделок в массив и добавляем количество звонков
      const uniqueLeads = Object.values(leadsMap).map(lead => ({
        ...lead,
        calls_count: lead.calls.length,
        has_calls: lead.calls.length > 0,
      }));

      console.log(`Найдено уникальных сделок: ${uniqueLeads.length}`);

      // Сохраняем результаты
      setLeads(uniqueLeads);
      
    } catch (err) {
      console.error("Ошибка при поиске сделок:", err);
      setApiError(err.message || "Произошла неизвестная ошибка");
      setLeads([]);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="py-6">
      <div className="text-center mb-12">
        <h1 className="text-4xl font-bold mb-4">
          Cистема <span className="gradient-text">анализа звонков</span> для стоматологических клиник, <br />разработанная на базе <span className="gradient-text">искусственного интеллекта</span>
        </h1>
      </div>

      {/* Форма поиска */}
      <div className="max-w-xl mx-auto bg-white p-8 rounded-lg shadow-lg mb-12 border border-gray-200">
        <h2 className="text-2xl font-semibold mb-6">Поиск по сделкам</h2>
        <SearchForm onSearch={handleSearch} loading={loading} />
      </div>

      {/* Сообщение об ошибке API */}
      {apiError && (
        <div className="mb-6 bg-red-100 text-red-800 p-4 rounded-md">
          <p className="font-bold">Ошибка API:</p>
          <p>{apiError}</p>
          <p className="text-sm mt-2 text-red-200">
            Если ошибка связана с таймаутом, попробуйте выбрать более короткий
            период или повторите запрос позже.
          </p>
        </div>
      )}

      {/* Результаты */}
      <div>
        {leads.length > 0 ? (
          <div>
            <h2 className="text-2xl font-semibold mb-4">
              Найдено сделок {searchPeriod ? `за период ${searchPeriod}` : ''}: {leads.length}
            </h2>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {leads.map((lead) => (
                <LeadCard key={lead.id} lead={lead} clientId={clientId} initialCalls={lead.calls} />
              ))}
            </div>
          </div>
        ) : (
          !loading &&
          !apiError && (
            <div className="text-center py-10 bg-gray-100 rounded-lg">
              <p className="text-gray-400">Нет данных для отображения</p>
              <p className="text-gray-500 text-sm mt-2">
                Введите Client ID и выберите дату для получения сделок
              </p>
            </div>
          )
        )}

        {loading && (
          <div className="flex flex-col items-center justify-center py-10">
            <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500 mb-4"></div>
            <p className="text-gray-400">Загрузка данных...</p>
            <p className="text-gray-500 text-xs mt-2">
              Выполняется параллельная обработка большого количества данных.
              Пожалуйста, подождите.
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default SearchPage;
